import React from 'react';

const ValueProps = () => {
  return (
    <section className="py-16 px-6 bg-white">
      <div className="container mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-midnight-navy">
          The Smartest Research Partner You'll Ever Have.
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Value Prop 1 */}
          <div className="bg-gray-50 p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow">
            <div className="text-4xl text-pale-gold mb-4">🔎</div>
            <h3 className="text-xl font-semibold mb-2 text-midnight-navy">Ask Anything</h3>
            <p className="text-gray-700">
              Fundamental questions, peer comparisons, valuation models — instantly.
            </p>
          </div>
          
          {/* Value Prop 2 */}
          <div className="bg-gray-50 p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow">
            <div className="text-4xl text-pale-gold mb-4">📈</div>
            <h3 className="text-xl font-semibold mb-2 text-midnight-navy">Get Rich Insights</h3>
            <p className="text-gray-700">
              Summaries, risks, catalysts, sentiment — not just numbers.
            </p>
          </div>
          
          {/* Value Prop 3 */}
          <div className="bg-gray-50 p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow">
            <div className="text-4xl text-pale-gold mb-4">⚡</div>
            <h3 className="text-xl font-semibold mb-2 text-midnight-navy">Work Lightning-Fast</h3>
            <p className="text-gray-700">
              Draft complete research memos 10x faster.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ValueProps;
